import instoreAllOffersMapModal from './InstoreAllOffersMapModal';

export default instoreAllOffersMapModal;
